<script setup lang="ts">

//vue
import { onMounted, reactive, watch } from "vue";

//servicos
import * as service from "@/services/BoletosService";
import {  fdata, f2dec,} from "@/utils/funcoes";


interface IProps {
    itens: service.BoletoRetornoItemDTO[];
}

interface IGrupo {
    id: string;
    descricao: string;
    qtde: number;
    valorUnit: number;
    valorTotal: number;
    valorTotalDoctos: number;
    itens: service.BoletoRetornoItemDTO[];
}

var props = defineProps<IProps>();

var controle = reactive({
    itens: [] as service.BoletoRetornoItemDTO[],
    grupos: [] as IGrupo[],
    processando: false
});

onMounted(() => {
    controle.itens = props.itens;
    agrupar();
})

watch(() => props.itens ,(newVal) => {
        controle.itens = newVal;
        agrupar();
    }
);

const agrupar = async () => {

    controle.processando = true;
    controle.grupos = [] as IGrupo[];

    var grupos = Object.groupBy(props.itens, ({motivosRejeicao}) => motivosRejeicao as PropertyKey);

    for (const key in grupos){
        var itensGrupo = props.itens.filter(x => x.motivosRejeicao == key);

        var grupo: IGrupo = {
            id: key,
            descricao: itensGrupo[0].motivosRejeicao || 'Sem descrição',
            qtde: itensGrupo.length,
            valorUnit: itensGrupo[0].valorDespesasCobranca + itensGrupo[0].valorOutrasDespesas || 0,
            valorTotal: itensGrupo.reduce((acc, item) => acc + ((item.valorDespesasCobranca || 0) + (item.valorOutrasDespesas || 0)), 0),
            valorTotalDoctos: itensGrupo.reduce((acc, item) => acc + (item.valorDocumento || 0), 0),
            itens: itensGrupo
        };
            controle.grupos.push(grupo);
    }
};



</script>

<template>
    <div class="col-md-12 col-12 fs-6 fw-bold">
        Resumo das tarifas
    </div>

    <table class="table table-sm table-bordered">
        <thead>
            <tr>
                <!-- <th>Cód</th> -->
                <th>Descrição</th>
                <th class="text-end">Qtde</th>
                <th class="text-end">Tarifa R$</th>
                <th class="text-end">Total Tarifa R$</th>
                <th class="text-end">Total Doctos R$</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="item in controle.grupos" :key="item.id" >
                <!-- <td>{{ item.id }}</td> -->
                <td>{{ item.descricao }}</td>
                <td class="text-end">{{ item.qtde }}</td>
                <td class="text-end">{{ f2dec(item.valorUnit) }}</td>
                <td class="text-end">{{ f2dec(item.valorTotal) }}</td>
                <td class="text-end">{{ f2dec(item.valorTotalDoctos) }}</td>
            </tr>
        </tbody>
        <tfoot>
            <tr class="fw-bold">
                <td>Total</td>
                <td class="text-end">{{ controle.grupos.reduce((acc, item) => acc + item.qtde, 0) }}</td>
                <td></td>
                <td class="text-end">{{ f2dec(controle.grupos.reduce((acc, item) => acc + item.valorTotal, 0)) }}</td>
                <td class="text-end">{{ f2dec(controle.grupos.reduce((acc, item) => acc + item.valorTotalDoctos, 0)) }}</td>
            </tr>
        </tfoot>
    </table>
</template>

<style scoped>

</style>